<template>
  <div>
    <div v-title data-title="供应商注册"></div>
    <div class="content" v-loading="initLoading" element-loading-text="初始化...">
      <div class="main">
        <el-form ref="form" id="form" :model="form" label-width="90px" :rules="rules">
          <el-form-item label="公司名称" prop="ghsmc">
            <el-input v-model="form.ghsmc" placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="简称" prop="sx">
            <el-input v-model="form.sx" placeholder="请限制在6个字以内"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="lxr">
            <el-input v-model="form.lxr" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="lxdh">
            <el-input v-model="form.lxdh" style="width:400px" placeholder="请输入联系电话"></el-input>
            <el-button type="primary" @click="sendCheckCode()" size="samll" style="width:105px"
              v-if="checkCode.countshow">发送验证码</el-button>
            <el-button type="primary" size="samll" style="width:105px" v-if="!checkCode.countshow">{{checkCode.count}}</el-button>
          </el-form-item>
           <el-form-item label="验证码" prop="yzm">
            <el-input v-model="form.yzm" style="width: 270px;"></el-input>
          </el-form-item>
          <el-form-item label="经营品类" prop="bq">
            <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)">{{tag}}</el-tag>
            <el-select v-model="inputValue" v-if="inputVisible" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm" @change="handleInputConfirm">
              <el-option v-for="item in tagOption" :key="item.id" :label="item.text" :value="item.id"></el-option>
            </el-select>
            <el-button v-else class="button-new-tag" size="small" @click="showInput"  type="primary" plain icon="el-icon-plus">添加</el-button>
          </el-form-item>
          <el-form-item label="发票类型" prop="fplx">
            <el-radio v-model="form.fplx" label="zp">专票</el-radio>
            <el-radio v-model="form.fplx" label="pp">普票</el-radio>

            <el-select v-model="form.shl" placeholder="税率" style="width: 100px; text-align: center">
              <el-option v-for="item in rateOption" :key="item.code" :label="item.code" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推荐人" prop="tjrid">
            <el-select v-model="form.tjrid" filterable remote reserve-keyword placeholder="请输入人员姓名"
              :remote-method="(query)=>{queryRecomanderOption(query)}" :loading="searchLoading" style="width: 270px;">
              <el-option v-for="item in recommanderOption" :key="item.id" :label="item.text" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司地址" prop="dz">
            <el-input type="textarea" v-model="form.dz"></el-input>
          </el-form-item>
          <el-form-item label="附件">
            <el-upload class="upload-demo"
              :action="annex.uploadUrl"
              :http-request="annexUpload"
              :on-remove="annexRemove"
              :file-list="annex.picList"
              list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传图片 且文件大小不能超过1M</div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submit" :loading="saveLoading">提交</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div style="margin-top:8px; margin-left:20px;"><font color="#F75A21">智中新窗业 @cooperation2022</font></div>
  </div>
</template>

<script>
import { initPk, register, recommander, category, checkCode, annxUpload, annxRemove } from '../../api/api'
let qs = require('qs')
export default {
  data () {
    return {
      initLoading: false,
      supplierKey: '',
      rateOption: [{code: 0}, {code: 1}, {code: 3}, {code: 6}, {code: 9}, {code: 13}],
      form: {
        ghsid: '',
        ghsmc: '',
        dz: '',
        lxr: '',
        lxdh: '',
        bq: '',
        tjrid: '',
        fplx: 'zp',
        shl: null
      },
      saveLoading: false,
      searchLoading: false,
      recommanderOption: [],
      tagOption: [],
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',

      checkCode: {
        loading: false,
        value: '', // 验证码内容
        backTime: '', // 验证码返回时间
        checkStatus: false, // 验证状态

        countshow: true,
        count: '',
        timer: null
      },

      // 附件上传
      annex: {
        visible: false,
        loading: false,
        index: 1,
        // uploadUrl: 'http://127.0.0.1:8769/api-auth/auth/register/supplier/annex/upload',
        uploadUrl: 'auth/register/supplier/annex/upload',
        picList: []
      },

      wHeight: document.documentElement.clientHeight * 0.9,

      rules: {
        ghsmc: [
          { required: true, message: '公司名称不能为空', trigger: 'blur' }
        ],
        sx: [
          { required: true, message: '简称不能为空', trigger: 'blur' }
        ],
        dz: [
          { required: true, message: '公司地址不能为空', trigger: 'change' }
        ],
        lxr: [
          { required: true, message: '联系人不能为空', trigger: 'change' }
        ],
        lxdh: [
          { required: true, message: '联系电话不能为空', trigger: 'change' }
        ],
        tjrid: [
          { required: true, message: '推荐人不能为空', trigger: 'change' }
        ],
        yzm: [
          {required: true, trigger: 'blur', validator: this.validCheckCode}
        ]
      }
    }
  },
  methods: {
    getPk () {
      this.initLoading = true
      initPk().then((res) => {
        this.initLoading = false
        this.supplierKey = res.data.data
      })
    },

    // 移除标签
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },

    // 添加标签
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.toggleMenu()
      })
    },

    // 确认标签
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },

    // 发送短信验证码
    sendCheckCode: function () {
      if (typeof (this.form.lxdh) === 'undefined' || this.form.lxdh === null || this.form.lxdh === '') {
        this.$notify({title: '提示', message: '请先填写联系电话', type: 'warning'})
        return false
      }

      let param = {
        'dh': this.form.lxdh
      }
      const TIME_COUNT = 300
      this.checkCode.loading = true
      checkCode(qs.stringify(param)).then((res) => {
        this.checkCode.loading = false
        if (res.data.state === '00000') {
          this.$message({message: '短信验证码已发送至您的手机 请注意查收(有效时间2分钟)', type: 'success'})
          this.checkCode.checkStatus = false
          this.checkCode.value = res.data.data

          this.checkCode.backTime = new Date()
          if (!this.checkCode.timer) {
            this.checkCode.count = TIME_COUNT
            this.checkCode.countshow = false
            this.checkCode.timer = setInterval(() => {
              if (this.checkCode.count > 0 && this.checkCode.count <= TIME_COUNT) {
                this.checkCode.count--
              } else {
                this.checkCode.countshow = true
                clearInterval(this.checkCode.timer)
                this.checkCode.timer = null
              }
            }, 1000)
          }
        } else {
          this.$message({message: res.data.message, type: 'error'})
        }
      })
    },

    // 校验短信验证码 需要添加后台重复发送验证
    validCheckCode: function (rules, val, callback) {
      // 未填写验证码
      if (val == null || typeof val === 'undefined') {
        return callback(new Error('验证码不能未空'))
      }
      // 未发送验证码
      if (this.checkCode.value == null || typeof this.checkCode.value === 'undefined' ||
        this.checkCode.value === '') {
        return callback(new Error('尚未发送验证码'))
      }
      // 已验证
      if (this.checkCode.checkStatus) {
        callback()
        // return callback(new Error('已验证通过 无需重复输入'))
      }
      // 验证码已过期
      if (!this.checkExpireTime()) {
        this.checkCode.value = null
        return callback(new Error('验证码已过期 请重新发送'))
      }
      // 验证失败
      if (this.checkCode.value !== val) {
        return callback(new Error('验证失败'))
      }
      // 验证通过
      this.checkCode.checkStatus = true
      callback()
    },

    // 判断验证码是否失效
    checkExpireTime: function () {
      let nowTime = new Date()
      let diffTimes = nowTime.getTime() - (this.checkCode.backTime).getTime()
      let diffMinute = diffTimes / parseFloat(60 * 1000)
      if (diffMinute > 5) {
        return false
      }
      return true
    },

    submit: function () {
      if (typeof (this.dynamicTags) === 'undefined' || this.dynamicTags.length === 0) {
        this.$notify({title: '提示', message: '经营品类不能为空', type: 'warning'})
        return false
      }
      if (!this.checkCode.checkStatus) {
        this.$notify({title: '提示', message: '请验证手机号后再提交注册信息', type: 'warning'})
        return false
      }
      if (typeof (this.annex.picList) === 'undefined' || this.annex.picList.length === 0) {
        this.$notify({title: '提示', message: '请上传营业资质附件 再提交注册信息', type: 'warning'})
        return false
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          if ((this.form.sx).length > 6) {
            this.$notify({title: '提示', message: '简称请限制在6个字以内', type: 'warning'})
            return false
          }

          this.form.ghsid = this.supplierKey
          this.form.bq = this.dynamicTags.join(',')
          this.saveLoading = true
          register(qs.stringify(this.form)).then((res) => {
            this.saveLoading = false
            if (res.data.state === '00000') {
              this.$message({message: '提交成功, 信息审核通过后会以短信形式通知 请耐心等待', type: 'success'})
              this.resetData()
            } else {
              this.$message({message: res.data.message, type: 'error'})
            }
          })
        }
      })
    },

    // 附件上传
    annexUpload: function (content) {
      let subffix = content.file.name
      subffix = subffix.substring(subffix.indexOf('.'))

      var formData = new FormData()
      formData.append('file', content.file)
      formData.append('djh', this.supplierKey)
      formData.append('lsh', this.annex.index)
      let tpsm = this.supplierKey + '_' + this.annex.index + subffix
      formData.append('tpsm', tpsm)
      let cflj = '/supplierRegister'
      formData.append('cflj', cflj)

      this.annex.loading = true
      annxUpload(content.action, formData).then((res) => {
        this.annex.loading = false
        if (res.data.state === '00000') {
          this.$message({type: 'success', message: '图片上传成功'})
          this.annex.visible = false
          this.annex.index = this.annex.index + 1
          this.annex.picList.push(res.data.data)
        } else {
          content.onError('图片上传失败')
        }
      })
    },

    // 附件移除
    annexRemove: function (file, fileList) {
      let param = {
        'djh': file.djh,
        'lsh': file.lsh,
        'tpsm': file.tpsm,
        'cflj': file.cflj
      }
      annxRemove(qs.stringify(param)).then((res) => {
        if (res.data.state === '00000') {
          this.$message({type: 'success', message: '移除成功'})
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    queryRecomanderOption: function (query) {
      if (query !== '') {
        this.searchLoading = true
        let param = {
          'ryxm': query
        }
        this.searchLoading = true
        recommander(qs.stringify(param)).then((res) => {
          this.searchLoading = false
          if (res.data.state === '00000') {
            this.recommanderOption = res.data.data
          } else {
            this.$message({message: '推荐人加载失败', type: 'error'})
          }
        })
      } else {
        this.recommanderOption = []
      }
    },

    initCategoryOption: function () {
      category().then((res) => {
        this.saveLoading = false
        if (res.data.state === '00000') {
          this.tagOption = res.data.data
        } else {
          this.$message({message: '经营品类加载失败', type: 'error'})
        }
      })
    },

    // 清空数据
    resetData: function () {
      this.getPk()
      this.form = {
        ghsid: '',
        ghsmc: '',
        dz: '',
        lxr: '',
        lxdh: '',
        bq: '',
        tjrid: ''
      }
      this.recommanderOption = []
      this.dynamicTags = []
      this.inputValue = ''
      this.checkCode = {
        loading: false,
        value: '',
        backTime: '',
        checkStatus: false,

        countshow: true,
        count: '',
        timer: null
      }
      this.annex = {
        visible: false,
        loading: false,
        index: 1,
        // uploadUrl: 'http://127.0.0.1:8769/api-auth/auth/register/supplier/annex/upload',
        uploadUrl: 'auth/register/supplier/annex/upload',
        picList: []
      }
    }
  },

  mounted () {
    this.getPk()
    this.initCategoryOption()
    document.getElementById('form').style = 'height:' + this.wHeight + 'px;'
  }
}
</script>

<style lang="scss" scoped>
  .main {
    position: absolute;
    width: 600px;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    overflow-y: scroll;
  }

  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  ::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/register/register.vue